import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#007ab2',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#007ab2',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#007ab2',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'inherit', // Default color
          '&.Mui-focused': {
            color: 'inherit', // Prevent color change on focus
          },
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff', // Default background color
          color: '#000000', // Default text color
        },
      },
    }
  },
  palette: {
    primary: {
      main: '#00638a',
    },
    secondary: {
      main: '#ffffff',
    },
    appLayer: {
      main: '#ffffff'
    },
    text: {
      primary: '#000000',
      secondary: '#333333',
    },
    input: {
      background: '#ffffff'
    },
    outline: {
      main: '#007ab2'
    }
  },
});

export const darkTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#28b1ec',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#28b1ec',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#28b1ec',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'inherit', // Default color
          '&.Mui-focused': {
            color: '#ffffff', // Prevent color change on focus
          },
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          backgroundColor: '#142737', // Default background color
          color: '#ffffff', // Default text color
        },
      },
    }
  },
  palette: {
    primary: {
      main: '#04142c',
    },
    secondary: {
      main: '#142737',
    },
    appLayer: {
      main: '#001526'
    },
    text: {
      main: '#ffffff',
      secondary: '#aaaaaa',
    },
    input: {
      background: '#1a222a'
    },
    outline: {
      main: '#28b1ec'
    }
  },
});